import React, { Component } from 'react'
import { Alert, Button, Form, Row, Col } from 'react-bootstrap'
import { NotificationManager } from 'react-notifications';
import Modal from 'react-bootstrap/Modal'
import api from '../api/axios'

class Manifest extends Component {

  constructor(props){
    super(props)
    this.state = {
      showModal: false,
      tag: '',
      resUUID: '',
      manifestStatus: null,
      deploy: false
    }
    this.getManifestStatus()
  }

  render() {
    let appendBtnText = '';
    if (this.state.manifestStatus) {
      if (this.state.manifestStatus.Error) {
        appendBtnText = ' (error)'
      } else {
        appendBtnText = ' (working...)'
      }
    }
    return(
      <div style={{ float: 'right', marginLeft: 5 }}>
        <Button
          variant="outline-primary"
          onClick={() => {
            this.setState({ showModal: true })
          }}>
          Push Manifest / Tag{ appendBtnText }
        </Button>
        { this.renderModal() }
      </div>
    )
  }

  getManifestStatus () {
    this.setState({ fetchingStatus: true })
    api.get('/pkgs/add/manifest')
      .then(res => {
        if (res.data) {
          setTimeout(() => {
            this.getManifestStatus()
          }, 2000)
        } else {
          if (this.state.manifestStatus) {
            try {
              this.props.onComplete()
            } catch (e) {}
          }
        }
        this.setState({ manifestStatus: res.data || null, fetchingStatus: false })
      })
      .catch(err => {
        NotificationManager.warning('Unable to check manifest status');
        this.setState({ fetchingStatus: false })
      })
  }

  putTag () {
    let deploy = this.state.deploy.toString()
    let url = `/pkgs/add/manifest/nex7/${this.state.tag}?&deploy=${deploy}`
    api.put(url)
      .then(res => {
        this.setState({ showModal: false })
        this.getManifestStatus()
        NotificationManager.success('Pushing tag...');
      })
      .catch(err => {
        console.log('err.response', err.response)
        let str = 'Error pushing tag'
        if (err && err.response && err.response.data) {
          str += err.response.data
        }
        NotificationManager.warning(str);
      })
  }

  stage () {
    this.putTag()
  }

  renderStatus () {
    if (!this.state.manifestStatus) {
      return null
    }
    return <>
      <Alert variant="primary">
        <strong>Currently processing task with UUID: { this.state.manifestStatus.UUID }</strong>
        {
          this.state.manifestStatus.Error
            ? (
              <span>Error: { this.state.manifestStatus.Error }</span>
            ) : null
        }
      </Alert>
      <hr />
    </>
  }

  renderModal () {
    return (
      <Modal
        size='lg'
        show={this.state.showModal}
        onHide={() => {}}
      >
        <Modal.Header>
          <Modal.Title className='h5'>
            Push Manifest or Tag
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          { this.renderStatus() }
          <Row className="g-3">
            <Col md>
              <h5>Nex7 Tag:</h5>
            </Col>
            <Col md>
              <Form.Group>
                <Form.Control type="text" placeholder="Nex7 Tag" onChange={(e) => this.setState({ tag: e.target.value })} />
              </Form.Group>
            </Col>
            <Col md>
              <Form.Group>
                <Form.Check type="checkbox" label="Deploy" checked={this.state.deploy} onChange={(e) => this.setState({deploy: !this.state.deploy})} />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='primary' size='sm' disabled={!this.state.tag} onClick={() => { this.stage() }}>Push Tag</Button>
          <Button variant='secondary' size='sm' onClick={() => { this.setState({ showModal: false }) }}>Close</Button>
        </Modal.Footer>
      </Modal>
    )
  }

}

export default Manifest
